import { render } from "./StockList.vue?vue&type=template&id=a56906b6&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"

import "./StockList.vue?vue&type=style&index=0&id=a56906b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56906b6"]])

export default __exports__